function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self1 = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self1, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { DisplayInfoDynamicRange, DisplayInfoResolutions } from '@sky-uk-ott/client-lib-js-device';
import { VideoColourSpace, VideoFormat } from '../../core/player/video-format';
import { sdkLogger } from '../../logger';
import { getProsperoDeviceVersion } from '../../utils/device-type';
import { getMediaSourceSupportedAudioFormats, isVideoCodecSupported } from '../../utils/probe-utils';
import { UhdHdrCodec } from '../../utils/probe-utils.enums';
var minimumSonyHdcpVersion = 2.3;
// minimum UHD HDCP version based on Sony's Documentation
var logger = sdkLogger.withContext('Prospero Capabilities');
function getDisplayInfo() {
    return _getDisplayInfo.apply(this, arguments);
}
function _getDisplayInfo() {
    _getDisplayInfo = // TODO move this access to the device client lib
    _async_to_generator(function() {
        var _self_msdk_device_getDisplayInfo, _self_msdk_device;
        return _ts_generator(this, function(_state) {
            return [
                2,
                (_self_msdk_device_getDisplayInfo = (_self_msdk_device = self.msdk.device).getDisplayInfo) === null || _self_msdk_device_getDisplayInfo === void 0 ? void 0 : _self_msdk_device_getDisplayInfo.call(_self_msdk_device).catch(function(e) {
                    var _self_msdk_device_getDisplayInfoImmediate, _self_msdk_device;
                    logger.warn('Unknown failure with getDisplayInfo, falling back to getDisplayInfoImmediate', e);
                    return (_self_msdk_device_getDisplayInfoImmediate = (_self_msdk_device = self.msdk.device).getDisplayInfoImmediate) === null || _self_msdk_device_getDisplayInfoImmediate === void 0 ? void 0 : _self_msdk_device_getDisplayInfoImmediate.call(_self_msdk_device);
                }).catch(function(e) {
                    logger.warn('Unknown failure with both getDisplayInfo and getDisplayInfoImmediate', e);
                    return undefined;
                })
            ];
        });
    });
    return _getDisplayInfo.apply(this, arguments);
}
function getMaxFrameRate() {
    return Infinity;
}
function getMaxVideoFormat(displayInfo) {
    return _getMaxVideoFormat.apply(this, arguments);
}
function _getMaxVideoFormat() {
    _getMaxVideoFormat = _async_to_generator(function(displayInfo) {
        var is4kCodecSupported, isHdcpSupported;
        return _ts_generator(this, function(_state) {
            is4kCodecSupported = isVideoCodecSupported(UhdHdrCodec.Uhd);
            isHdcpSupported = (displayInfo === null || displayInfo === void 0 ? void 0 : displayInfo.hdcpVersion) && parseFloat(displayInfo === null || displayInfo === void 0 ? void 0 : displayInfo.hdcpVersion) >= minimumSonyHdcpVersion;
            if (is4kCodecSupported && isHdcpSupported && (displayInfo === null || displayInfo === void 0 ? void 0 : displayInfo.resolution) === DisplayInfoResolutions.Res_4k) {
                return [
                    2,
                    VideoFormat.UHD
                ];
            }
            return [
                2,
                VideoFormat.HD
            ];
        });
    });
    return _getMaxVideoFormat.apply(this, arguments);
}
function getSupportedColourSpaces(displayInfo) {
    return _getSupportedColourSpaces.apply(this, arguments);
}
function _getSupportedColourSpaces() {
    _getSupportedColourSpaces = _async_to_generator(function(displayInfo) {
        var isUhdHdrSupported, colourSpaces;
        return _ts_generator(this, function(_state) {
            isUhdHdrSupported = isVideoCodecSupported(UhdHdrCodec.Hdr10);
            // consider move the bellow call to msdk to the device and call a device method here.
            colourSpaces = [
                VideoColourSpace.SDR
            ];
            // Sony does not support Dolby Vision instead they support `Auto HDR Tone Mapping`
            if (isUhdHdrSupported && (displayInfo === null || displayInfo === void 0 ? void 0 : displayInfo.dynamicRange) === DisplayInfoDynamicRange.HDR) {
                colourSpaces.push(VideoColourSpace.HDR10, VideoColourSpace.HDRHLG);
            }
            return [
                2,
                colourSpaces
            ];
        });
    });
    return _getSupportedColourSpaces.apply(this, arguments);
}
function getSupportedAudioFormats() {
    return getMediaSourceSupportedAudioFormats();
}
function getPreloadSupport(device) {
    var isPlayStation5 = getProsperoDeviceVersion(device.deviceInfo, device.type) === 5;
    return {
        preconstructItems: isPlayStation5,
        preloadItems: false,
        hasPrefetchSupport: false
    };
}
function getCompatibleStreamPropertyGroups(device) {
    return _getCompatibleStreamPropertyGroups.apply(this, arguments);
}
function _getCompatibleStreamPropertyGroups() {
    _getCompatibleStreamPropertyGroups = _async_to_generator(function(device) {
        var displayInfo, _ref, maxFrameRate, maxVideoFormat, supportedColourSpaces;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getDisplayInfo()
                    ];
                case 1:
                    displayInfo = _state.sent();
                    return [
                        4,
                        Promise.all([
                            getMaxFrameRate(),
                            getMaxVideoFormat(displayInfo),
                            getSupportedColourSpaces(displayInfo)
                        ])
                    ];
                case 2:
                    _ref = _sliced_to_array.apply(void 0, [
                        _state.sent(),
                        3
                    ]), maxFrameRate = _ref[0], maxVideoFormat = _ref[1], supportedColourSpaces = _ref[2];
                    return [
                        2,
                        [
                            {
                                maxFrameRate: maxFrameRate,
                                maxVideoFormat: maxVideoFormat,
                                supportedColourSpaces: supportedColourSpaces
                            }
                        ]
                    ];
            }
        });
    });
    return _getCompatibleStreamPropertyGroups.apply(this, arguments);
}
function getHdcpCompliance() {
    return _getHdcpCompliance.apply(this, arguments);
}
function _getHdcpCompliance() {
    _getHdcpCompliance = _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            return [
                2,
                true
            ];
        });
    });
    return _getHdcpCompliance.apply(this, arguments);
}
export var mseProsperoCapabilities = {
    getCompatibleStreamPropertyGroups: getCompatibleStreamPropertyGroups,
    getSupportedAudioFormats: getSupportedAudioFormats,
    getPreloadSupport: getPreloadSupport,
    getHdcpCompliance: getHdcpCompliance
};

//# sourceMappingURL=mse-capabilities.js.map